export enum PlanningTranslations {
  GTPPrioritiesOnlineTip = 'jbp-gtm-priorities-online-tip',
  GTPPrioritiesInstoreTip = 'jbp-gtm-priorities-instore-tip',
  ContractualTotal = 'jbp-planning-contractual-total',
}

export const ComposedReportPlanningTranslations = {
  noDataWarning: 'jbp-planning-no-data',
  dataError: 'jbp-planning-data-error',
  distributorRegionalPlanningInfo: 'jbp-distributor-regional-planning-info',
  distributorGroupPlanningIFnfo: 'jbp-distributor-group-planning-info',
}

export default ComposedReportPlanningTranslations
